<template>
  <ProductBadgeSale
    v-if="product.prices.discountType === 'sales'"
    :discount-markdown="product.prices.discountMarkdown"
  />
  <ProductBadgeImage
    v-else-if="attributeOptions"
    :attribute-value="attributeOptions"
    :default-locale="shop.default_locale_iso_code"
  />
</template>

<script setup>
import { computed } from 'vue';
import ProductBadgeSale from './ProductBadgeSale.vue';
import ProductBadgeImage from './ProductBadgeImage.vue';

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  shop: {
    type: Object,
    required: true,
  },
});

const attributeOptions = computed(() => props.product.attribute_values
  .filter((attributeValue) => attributeValue.attribute.code === 'options'
    || attributeValue.attribute.code === 'made_in')
  .sort((a, b) => {
    const priority = {
      miliprix: 1,
      design_by_miliboo: 2,
      miliboo_kids: 3,
      made_in_france: 4,
      made_in_italy: 5,
      made_in_europe: 6,
      newest: 7,
    };
    return (priority[a.default_value.code] ?? 0) - (priority[b.default_value.code] ?? 0);
  })
  .at(0));
</script>
